
<template>
  <Loader v-if="loader" />

  <div class="card">
    <div class="formgrid grid ">
        <div class="field col-12 md:col-3">
            <label>Inserisci Anno da controllare</label>
            <Calendar v-model="date" :showIcon="true" view="year" dateFormat="yy" :class="['inputfield w-full',{'p-invalid': validationErrors.data && submitted}]" />
            <div v-show="validationErrors.data && submitted" class="p-error">Seleziona anno</div>
        </div>
        <!-- <div class="field col-12 md:col-3">
            <label>Rappresentante</label>
            <Dropdown v-model="selectedRappresentante" :options=" rappresentanti" optionLabel="name" optionValue="id" :filter="true" dataKey="id"  class="inputfield w-full" />
        </div> -->
        <div class="field col-12 md:col-3 flex align-items-end justify-content-center">
            <Button label="Cerca" icon="pi pi-search" iconPos="right" class="w-full" @click="searchData" />
        </div>
    </div>
  </div>

  
  <TabView lazy v-model:activeIndex="activeTabIndex">
    <TabPanel v-for="tab in tabs" :key="tab.anno">
      <template v-if="tab" #header>
          <span>{{tab.title}}</span>
          <!-- <div class="badge">
              {{tab.data.length}} <small class="ml-1">su {{tab.total}}</small> 
          </div>              -->
          <div class="badge">
              {{tab.data.length}} 
          </div>             

      </template>

      <DataTable :ref="`dt_${activeTabIndex}`" :value="tab.data" :paginator="true" :rows="10" :filters="filters" exportFilename="acquisto-vendita"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10,20,50]" responsiveLayout="scroll"
          currentPageReportTemplate="{first} a {last} di {totalRecords}">
          <template #header>
            <div class="flex justify-content-between flex-wrap">
                <div class="flex align-items-center justify-content-center mb-2">
                   <span class="p-input-icon-left">
                      <i class="pi pi-search" />
                      <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                  </span>
                </div>
                <!-- <div class="flex align-items-center justify-content-center">
                   <Button icon="pi pi-external-link" label="Esporta" @click="exportCSV(activeTabIndex)" class="p-button-secondary" />
                </div> -->
            </div>
          </template>

         <template #empty>
              <div class="text-center">Nessun dato trovato.</div>
          </template> 
          <Column field="senderName" header="Fornitore" :sortable="true"></Column>
          <Column field="td" header="Tipo Documento" :sortable="true"></Column>
          <Column field="docId" header="Numero documento" :sortable="true"></Column>
          <Column field="docDate" header="Data documento" :sortable="true"></Column>
          <Column field="receiptDate" header="Data ricezione" :sortable="true"></Column>
          <Column field="hubId" header="ID SDI" :sortable="true"></Column>

          <!-- <Column field="taxAmount" header="Imponibile" :sortable="true">
            <template #body="{data}">
              {{formatCurrency(data.taxAmount)}}
            </template>
          </Column>
          <Column field="paymentAmount" header="Imponibile" :sortable="true"></Column>

          <Column field="totalAmount" header="Totale Fattura" :sortable="true">
            <template #body="{data}">
              {{formatCurrency(data.totalAmount)}}
            </template>
          </Column> -->



          <!-- <Column  field="cod_type_periodo" header="Fatturazione" :sortable="true">
            <template #body="{data}" >
              {{data.cod_type_periodo ==  2 ? 'Bimestrale' : 'Mensile'}}    
            </template>
          </Column> -->
      </DataTable>
      
    </TabPanel>
  </TabView>




</template>

<script>
// import moment from 'moment'
import Service from '@/services/ask-management/fatture-acquisto-service'
import { ref, onMounted, getCurrentInstance  } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'


export default {
  components: {
    Loader
  },
  setup() {

    const dt = ref();
    const loader = ref(false)
    const activeTabIndex = ref(0);
    const tabs = ref([]);
    const typesFornitura = ref(['pod','pdr']);
    const types = ref(['Fatturazione','Rcu']);
    const selectedTipoFornitura = ref();
    const selectedTipo = ref();
    const filters = ref({
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
    });
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const date = ref(new Date());

    // const rappresentanti = ref([])
    // const selectedRappresentante = ref(0)
    const validationErrors = ref({})
    const submitted = ref(false)

    onMounted(() => {       

    })

    // service.getRappresentanti().then((res) => {
    //   rappresentanti.value = res.items
    // })



    const exportCSV = (index) => {
      self.refs[`dt_${index}`].exportCSV()
    };

    const searchData = () => {
      loader.value = true;
      let year;
      if(validateData()){
        year = date.value.getFullYear();
        service.getControlloFattureAcquisto(year)
        .then((res) => {
          // console.log(res);
            tabs.value = res.items
            console.log(tabs.value)
          }).finally(() => {
              loader.value = false
          })

      }
    }

    const validateData = () =>{
      if (date.value == null)
        validationErrors.value['date'] = true;
      else 
        delete validationErrors.value['date'];
      
      // if (selectedTipo.value == null)
      //   validationErrors.value['type'] = true;
      // else 
      //   delete validationErrors.value['type'];

      // if (selectedTipoFornitura.value == null)
      //   validationErrors.value['typeFornitura'] = true;
      // else 
      //   delete validationErrors.value['typeFornitura'];
  
      return !Object.keys(validationErrors.value).length;
    }

    const formatCurrency = (value) => {
        return value.toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
      };

    return { 
      dt,
      tabs,
      // rappresentanti,
      // selectedRappresentante,
      activeTabIndex,
      typesFornitura,
      types,
      selectedTipoFornitura,
      selectedTipo,
      loader, 
      filters, 
      date,
      searchData,
      exportCSV,
      validationErrors,
      submitted,
      formatCurrency
    }
  }
}
</script>


<style scoped>
.badge {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: var(--primary-color);
    background-color: rgb(184, 229, 253);
    padding: 4px 7px;
    margin-left: 6px;
    border-radius: 3px;
}

</style>

